import React, { useState } from 'react';
import {
  DialogPayload,
  DialogSecondaryAction,
  DialogTitleWithCloseAction,
  useDialogPromise
} from '@ianesthesie-kit/redux';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  TextField
} from '@mui/material';
import { TranslatedText } from '@ianesthesie-kit/core';
import { motion } from 'framer-motion';
import { TelInput } from '@/components/telInput';
import { matchIsValidTel } from '@ianesthesie-kit/tel-input';
import type { AppDialogType as AppDialogTypeT } from '@/config';
import { AppDialogType } from '@/config';
import { StandardDialogContainer } from './common';

export const InputDialog = ({
  message,
  title,
  dialogType
}: DialogPayload<AppDialogTypeT & any>) => {
  const { closeAndResolve } = useDialogPromise();
  const [value, setValue] = useState('');

  return (
    <StandardDialogContainer>
      <DialogTitleWithCloseAction onClose={() => closeAndResolve(undefined)}>
        {title}
      </DialogTitleWithCloseAction>
      <DialogContent sx={{ position: 'relative', minHeight: 80 }}>
        <motion.div
          initial={{ y: 10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -10, opacity: 0 }}
        >
          <DialogContentText>{message}</DialogContentText>
          <div>
            {dialogType === AppDialogType.INPUT && (
              <TextField
                fullWidth
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
            )}

            {dialogType === AppDialogType.TEL_INPUT && (
              <TelInput
                fullWidth
                error={!!value && !matchIsValidTel(value)}
                value={value ?? ''}
                onChange={(v, info) => {
                  if (
                    info.numberValue &&
                    info.countryCallingCode &&
                    info.countryCallingCode !== info.numberValue
                  ) {
                    setValue(info.numberValue);
                  } else {
                    setValue('');
                  }
                }}
              />
            )}
          </div>
        </motion.div>
      </DialogContent>
      <DialogActions>
        <DialogSecondaryAction onClick={() => closeAndResolve(undefined)}>
          <TranslatedText id="app.cancel" />
        </DialogSecondaryAction>
        <Button disabled={!value} onClick={() => closeAndResolve(value)}>
          <TranslatedText id="app.ok" />
        </Button>
      </DialogActions>
    </StandardDialogContainer>
  );
};
